"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("DeleteCross", React.createElement("path", { stroke: "currentColor", d: "M.7 23.4L23.4.7M23.4 23.4L.7.7" }));
//# sourceMappingURL=DeleteCross.js.map